<template>
  <div>
    <router-view/>
    <cookie-law 
      :message="$t('general.cookies.message')"
      :button-text="$t('general.cookies.buttton.text')"
      :button-link-text="$t('general.cookies.linkbuttton.text')"
      :button-link="{name:'Cookies'}"
      theme="base"/>
  </div>
</template>

<script>
// const debug = require('debug')('OD::App')

import CookieLaw from 'vue-cookie-law'
import 'vuetify/dist/vuetify.min.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'

export default {
  components: { CookieLaw },
}
</script>

<style lang="scss">
.btn {
  min-width: auto;
}
@media only screen and (max-width: 599px) {
  .container {
    padding: 15px;
  }
}
.markdown {
  h2 {
    margin-top: 20px;
  }
  h3 {
    margin-top: 10px;
  }
  hr {
    border-top: 1px solid #8c8b8b;
    border-bottom: 1px solid #fff;
  }
  ul {
    margin-left: 20px;
  }
  ol {
    margin-left: 15px;
  }
}
</style>
